// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/irish-dancing.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const irishDancing: Score = {
  slug: "irish-dancing",
  n: 16,
  title: "Irish Dancing",
  composer: "Jason Zac",
  rights: "original",
  publicSafe: true,
  key: "D",
  fifths: 2,
  time: [4, 4],
  tempo: 100,
  staves: 2,
  clefs: ["treble", "bass"],
  bars: 16,
  barQuarters: 4.0,
  lowest: 43,
  highest: 71,
  hasLyrics: false,
  jasonNote: "I've always been a lover of Folk music especially Irish tunes. Have fun playing this one which I've composed on the key of D Major",
  teaches: [
    "the folk idiom",
    "running left-hand quavers",
    "a sustained right hand over constant motion",
    "rolled chords at the close"
  ],
  art: "/sight-reading/art/irish-dancing.jpg",
  artRights: "stock",
  background: "/sight-reading/bg/irish-dancing.jpg",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 3.0, midi: 69, pitch: "A4", d: "half", dot: true },
    { bar: 1, hand: "lh", start: 0.0, dur: 0.5, midi: 50, pitch: "D3", d: "eighth" },
    { bar: 1, hand: "lh", start: 0.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 1, hand: "lh", start: 1.0, dur: 0.5, midi: 54, pitch: "F#3", d: "eighth" },
    { bar: 1, hand: "lh", start: 1.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 1, hand: "lh", start: 2.0, dur: 0.5, midi: 50, pitch: "D3", d: "eighth" },
    { bar: 1, hand: "lh", start: 2.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 1, hand: "rh", start: 3.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 1, hand: "lh", start: 3.0, dur: 0.5, midi: 54, pitch: "F#3", d: "eighth" },
    { bar: 1, hand: "lh", start: 3.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 2, hand: "rh", start: 4.0, dur: 3.0, midi: 69, pitch: "A4", d: "half", dot: true },
    { bar: 2, hand: "lh", start: 4.0, dur: 0.5, midi: 49, pitch: "C#3", d: "eighth" },
    { bar: 2, hand: "lh", start: 4.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 2, hand: "lh", start: 5.0, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 2, hand: "lh", start: 5.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 2, hand: "lh", start: 6.0, dur: 0.5, midi: 49, pitch: "C#3", d: "eighth" },
    { bar: 2, hand: "lh", start: 6.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 2, hand: "rh", start: 7.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 2, hand: "lh", start: 7.0, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 2, hand: "lh", start: 7.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 3, hand: "rh", start: 8.0, dur: 2.0, midi: 66, pitch: "F#4", d: "half" },
    { bar: 3, hand: "lh", start: 8.0, dur: 0.5, midi: 50, pitch: "D3", d: "eighth" },
    { bar: 3, hand: "lh", start: 8.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 3, hand: "lh", start: 9.0, dur: 0.5, midi: 54, pitch: "F#3", d: "eighth" },
    { bar: 3, hand: "lh", start: 9.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 3, hand: "rh", start: 10.0, dur: 2.0, midi: 64, pitch: "E4", d: "half" },
    { bar: 3, hand: "lh", start: 10.0, dur: 0.5, midi: 49, pitch: "C#3", d: "eighth" },
    { bar: 3, hand: "lh", start: 10.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 3, hand: "lh", start: 11.0, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 3, hand: "lh", start: 11.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 4, hand: "rh", start: 12.0, dur: 3.0, midi: 62, pitch: "D4", d: "half", dot: true },
    { bar: 4, hand: "lh", start: 12.0, dur: 0.5, midi: 50, pitch: "D3", d: "eighth" },
    { bar: 4, hand: "lh", start: 12.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 4, hand: "lh", start: 13.0, dur: 0.5, midi: 54, pitch: "F#3", d: "eighth" },
    { bar: 4, hand: "lh", start: 13.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 4, hand: "lh", start: 14.0, dur: 1.0, midi: 50, pitch: "D3", d: "quarter" },
    { bar: 4, hand: "rh", start: 15.0, dur: 0.75, midi: 69, pitch: "A4", d: "eighth", dot: true },
    { bar: 4, hand: "lh", start: 15.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 4, hand: "rh", start: 15.75, dur: 0.25, midi: 66, pitch: "F#4", d: "16th" },
    { bar: 5, hand: "rh", start: 16.0, dur: 3.0, midi: 59, pitch: "B3", d: "half", dot: true },
    { bar: 5, hand: "lh", start: 16.0, dur: 0.5, midi: 43, pitch: "G2", d: "eighth" },
    { bar: 5, hand: "lh", start: 16.5, dur: 0.5, midi: 50, pitch: "D3", d: "eighth" },
    { bar: 5, hand: "lh", start: 17.0, dur: 0.5, midi: 47, pitch: "B2", d: "eighth" },
    { bar: 5, hand: "lh", start: 17.5, dur: 0.5, midi: 50, pitch: "D3", d: "eighth" },
    { bar: 5, hand: "lh", start: 18.0, dur: 0.5, midi: 43, pitch: "G2", d: "eighth" },
    { bar: 5, hand: "lh", start: 18.5, dur: 0.5, midi: 50, pitch: "D3", d: "eighth" },
    { bar: 5, hand: "rh", start: 19.0, dur: 1.0, midi: 66, pitch: "F#4", d: "quarter" },
    { bar: 5, hand: "lh", start: 19.0, dur: 0.5, midi: 47, pitch: "B2", d: "eighth" },
    { bar: 5, hand: "lh", start: 19.5, dur: 0.5, midi: 50, pitch: "D3", d: "eighth" },
    { bar: 6, hand: "rh", start: 20.0, dur: 3.0, midi: 64, pitch: "E4", d: "half", dot: true },
    { bar: 6, hand: "lh", start: 20.0, dur: 0.5, midi: 45, pitch: "A2", d: "eighth" },
    { bar: 6, hand: "lh", start: 20.5, dur: 0.5, midi: 52, pitch: "E3", d: "eighth" },
    { bar: 6, hand: "lh", start: 21.0, dur: 0.5, midi: 49, pitch: "C#3", d: "eighth" },
    { bar: 6, hand: "lh", start: 21.5, dur: 0.5, midi: 52, pitch: "E3", d: "eighth" },
    { bar: 6, hand: "lh", start: 22.0, dur: 0.5, midi: 45, pitch: "A2", d: "eighth" },
    { bar: 6, hand: "lh", start: 22.5, dur: 0.5, midi: 52, pitch: "E3", d: "eighth" },
    { bar: 6, hand: "rh", start: 23.0, dur: 0.75, midi: 66, pitch: "F#4", d: "eighth", dot: true },
    { bar: 6, hand: "lh", start: 23.0, dur: 0.5, midi: 49, pitch: "C#3", d: "eighth" },
    { bar: 6, hand: "lh", start: 23.5, dur: 0.5, midi: 52, pitch: "E3", d: "eighth" },
    { bar: 6, hand: "rh", start: 23.75, dur: 0.25, midi: 64, pitch: "E4", d: "16th" },
    { bar: 7, hand: "rh", start: 24.0, dur: 4.0, midi: 62, pitch: "D4", d: "whole", tie: "start" },
    { bar: 7, hand: "lh", start: 24.0, dur: 0.5, midi: 50, pitch: "D3", d: "eighth" },
    { bar: 7, hand: "lh", start: 24.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 7, hand: "lh", start: 25.0, dur: 0.5, midi: 54, pitch: "F#3", d: "eighth" },
    { bar: 7, hand: "lh", start: 25.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 7, hand: "lh", start: 26.0, dur: 0.5, midi: 50, pitch: "D3", d: "eighth" },
    { bar: 7, hand: "lh", start: 26.5, dur: 0.5, midi: 59, pitch: "B3", d: "eighth" },
    { bar: 7, hand: "lh", start: 27.0, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 7, hand: "lh", start: 27.5, dur: 0.5, midi: 59, pitch: "B3", d: "eighth" },
    { bar: 8, hand: "rh", start: 28.0, dur: 4.0, midi: 62, pitch: "D4", d: "whole", tie: "stop" },
    { bar: 8, hand: "lh", start: 28.0, dur: 0.5, midi: 50, pitch: "D3", d: "eighth" },
    { bar: 8, hand: "lh", start: 28.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 8, hand: "lh", start: 29.0, dur: 0.5, midi: 54, pitch: "F#3", d: "eighth" },
    { bar: 8, hand: "lh", start: 29.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 8, hand: "lh", start: 30.0, dur: 2.0, midi: 50, pitch: "D3", d: "half" },
    { bar: 9, hand: "rh", start: 32.0, dur: 3.0, midi: 69, pitch: "A4", d: "half", dot: true },
    { bar: 9, hand: "lh", start: 32.0, dur: 0.5, midi: 50, pitch: "D3", d: "eighth" },
    { bar: 9, hand: "lh", start: 32.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 9, hand: "lh", start: 33.0, dur: 0.5, midi: 54, pitch: "F#3", d: "eighth" },
    { bar: 9, hand: "lh", start: 33.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 9, hand: "lh", start: 34.0, dur: 0.5, midi: 50, pitch: "D3", d: "eighth" },
    { bar: 9, hand: "lh", start: 34.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 9, hand: "rh", start: 35.0, dur: 1.0, midi: 71, pitch: "B4", d: "quarter" },
    { bar: 9, hand: "lh", start: 35.0, dur: 0.5, midi: 54, pitch: "F#3", d: "eighth" },
    { bar: 9, hand: "lh", start: 35.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 10, hand: "rh", start: 36.0, dur: 3.0, midi: 69, pitch: "A4", d: "half", dot: true },
    { bar: 10, hand: "lh", start: 36.0, dur: 0.5, midi: 49, pitch: "C#3", d: "eighth" },
    { bar: 10, hand: "lh", start: 36.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 10, hand: "lh", start: 37.0, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 10, hand: "lh", start: 37.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 10, hand: "lh", start: 38.0, dur: 0.5, midi: 49, pitch: "C#3", d: "eighth" },
    { bar: 10, hand: "lh", start: 38.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 10, hand: "rh", start: 39.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter" },
    { bar: 10, hand: "lh", start: 39.0, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 10, hand: "lh", start: 39.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 11, hand: "rh", start: 40.0, dur: 2.0, midi: 66, pitch: "F#4", d: "half" },
    { bar: 11, hand: "lh", start: 40.0, dur: 0.5, midi: 50, pitch: "D3", d: "eighth" },
    { bar: 11, hand: "lh", start: 40.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 11, hand: "lh", start: 41.0, dur: 0.5, midi: 54, pitch: "F#3", d: "eighth" },
    { bar: 11, hand: "lh", start: 41.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 11, hand: "rh", start: 42.0, dur: 2.0, midi: 64, pitch: "E4", d: "half" },
    { bar: 11, hand: "lh", start: 42.0, dur: 0.5, midi: 49, pitch: "C#3", d: "eighth" },
    { bar: 11, hand: "lh", start: 42.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 11, hand: "lh", start: 43.0, dur: 0.5, midi: 55, pitch: "G3", d: "eighth" },
    { bar: 11, hand: "lh", start: 43.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 12, hand: "rh", start: 44.0, dur: 3.0, midi: 62, pitch: "D4", d: "half", dot: true },
    { bar: 12, hand: "lh", start: 44.0, dur: 0.5, midi: 50, pitch: "D3", d: "eighth" },
    { bar: 12, hand: "lh", start: 44.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 12, hand: "lh", start: 45.0, dur: 0.5, midi: 54, pitch: "F#3", d: "eighth" },
    { bar: 12, hand: "lh", start: 45.5, dur: 0.5, midi: 57, pitch: "A3", d: "eighth" },
    { bar: 12, hand: "lh", start: 46.0, dur: 2.0, midi: 50, pitch: "D3", d: "half" },
    { bar: 12, hand: "rh", start: 47.0, dur: 0.75, midi: 69, pitch: "A4", d: "eighth", dot: true },
    { bar: 12, hand: "rh", start: 47.75, dur: 0.25, midi: 66, pitch: "F#4", d: "16th" },
    { bar: 13, hand: "rh", start: 48.0, dur: 3.0, midi: 59, pitch: "B3", d: "half", dot: true },
    { bar: 13, hand: "lh", start: 48.0, dur: 0.5, midi: 43, pitch: "G2", d: "eighth" },
    { bar: 13, hand: "lh", start: 48.5, dur: 0.5, midi: 50, pitch: "D3", d: "eighth" },
    { bar: 13, hand: "lh", start: 49.0, dur: 0.5, midi: 47, pitch: "B2", d: "eighth" },
    { bar: 13, hand: "lh", start: 49.5, dur: 0.5, midi: 50, pitch: "D3", d: "eighth" },
    { bar: 13, hand: "lh", start: 50.0, dur: 0.5, midi: 43, pitch: "G2", d: "eighth" },
    { bar: 13, hand: "lh", start: 50.5, dur: 0.5, midi: 50, pitch: "D3", d: "eighth" },
    { bar: 13, hand: "rh", start: 51.0, dur: 0.75, midi: 69, pitch: "A4", d: "eighth", dot: true },
    { bar: 13, hand: "lh", start: 51.0, dur: 0.5, midi: 47, pitch: "B2", d: "eighth" },
    { bar: 13, hand: "lh", start: 51.5, dur: 0.5, midi: 50, pitch: "D3", d: "eighth" },
    { bar: 13, hand: "rh", start: 51.75, dur: 0.25, midi: 66, pitch: "F#4", d: "16th" },
    { bar: 14, hand: "rh", start: 52.0, dur: 3.0, midi: 64, pitch: "E4", d: "half", dot: true },
    { bar: 14, hand: "lh", start: 52.0, dur: 0.5, midi: 45, pitch: "A2", d: "eighth" },
    { bar: 14, hand: "lh", start: 52.5, dur: 0.5, midi: 52, pitch: "E3", d: "eighth" },
    { bar: 14, hand: "lh", start: 53.0, dur: 0.5, midi: 49, pitch: "C#3", d: "eighth" },
    { bar: 14, hand: "lh", start: 53.5, dur: 0.5, midi: 52, pitch: "E3", d: "eighth" },
    { bar: 14, hand: "lh", start: 54.0, dur: 0.5, midi: 45, pitch: "A2", d: "eighth" },
    { bar: 14, hand: "lh", start: 54.5, dur: 0.5, midi: 52, pitch: "E3", d: "eighth" },
    { bar: 14, hand: "rh", start: 55.0, dur: 0.75, midi: 66, pitch: "F#4", d: "eighth", dot: true },
    { bar: 14, hand: "lh", start: 55.0, dur: 0.5, midi: 49, pitch: "C#3", d: "eighth" },
    { bar: 14, hand: "lh", start: 55.5, dur: 0.5, midi: 52, pitch: "E3", d: "eighth" },
    { bar: 14, hand: "rh", start: 55.75, dur: 0.25, midi: 64, pitch: "E4", d: "16th" },
    { bar: 15, hand: "rh", start: 56.0, dur: 4.0, midi: 62, pitch: "D4", d: "whole", tie: "start" },
    { bar: 15, hand: "lh", start: 56.0, dur: 2.0, midi: 50, pitch: "D3", d: "half" },
    { bar: 15, hand: "lh", start: 56.0, dur: 2.0, midi: 54, pitch: "F#3", d: "half", chord: true },
    { bar: 15, hand: "lh", start: 56.0, dur: 2.0, midi: 57, pitch: "A3", d: "half", chord: true },
    { bar: 15, hand: "lh", start: 58.0, dur: 1.0, midi: 50, pitch: "D3", d: "quarter" },
    { bar: 15, hand: "lh", start: 58.0, dur: 1.0, midi: 55, pitch: "G3", d: "quarter", chord: true },
    { bar: 15, hand: "lh", start: 58.0, dur: 1.0, midi: 59, pitch: "B3", d: "quarter", chord: true },
    { bar: 15, hand: "lh", start: 59.0, dur: 1.0, rest: true, d: "quarter" },
    { bar: 16, hand: "rh", start: 60.0, dur: 4.0, midi: 62, pitch: "D4", d: "whole", tie: "stop" },
    { bar: 16, hand: "lh", start: 60.0, dur: 4.0, midi: 50, pitch: "D3", d: "whole" },
    { bar: 16, hand: "lh", start: 60.0, dur: 4.0, midi: 54, pitch: "F#3", d: "whole", chord: true },
    { bar: 16, hand: "lh", start: 60.0, dur: 4.0, midi: 57, pitch: "A3", d: "whole", chord: true },
  ],
};
